import { SELECTORS } from './selectors';

const $ = jQuery;

export function toggleButtonState(id, hasConditions) {
	const $button = $(`${SELECTORS.openButton}[data-post-id="${id}"]`);

	const className = 'has-conditions';

	return hasConditions
		? $button.addClass(className)
		: $button.removeClass(className);
}

export function setHookName($context, reset = true) {
	const $selectHookField = $context.find(SELECTORS.hook);

	const hookName = $selectHookField.val();
	const $customHookField = $context.find(SELECTORS.hookName);

	if (hookName === 'custom') {
		$customHookField.attr('disabled', false);
		if (reset) {
			$customHookField.val('');
		}
	} else {
		$customHookField.attr('disabled', true);
		$customHookField.val(hookName);
	}
}

export function shouldHookNameBeEditable($modal) {
	$modal
		.find(SELECTORS.context)
		.get()
		.forEach((context) => setHookName($(context), false));
}
